<section class="bf-map">
  <div #mapEl class="bf-map__canvas"></div>
</section>
